var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_content"},[_c('div',{staticClass:"page_edit_content"},[_c('Form',{ref:"form",attrs:{"form_data":_vm.form_data},on:{"handleSubmit":_vm.handleSubmit}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }